import React from "react";
import { Col, Row } from "cakemail-ui-components/lib/react";
import PropTypes from "prop-types";
import classNames from "classnames";

const SectionHeading = (props) => {
	const classes = classNames("sectionHeading", props.className);

	let leftTools = props.leftToolComponents.map((tool, index) => {
		return (
			<div className="sectionHeadingTool" key={index}>
				{tool}
			</div>
		);
	});

	let rightTools = props.rightToolComponents.map((tool, index) => {
		return (
			<div className="sectionHeadingTool" key={index}>
				{tool}
			</div>
		);
	});

	return (
		<Row className={classes}>
			<Col xs={6} className="leftSectionHeadingToolContainer">
				{leftTools}
			</Col>
			<Col xs={6} className="rightSectionHeadingToolContainer">
				{rightTools}
			</Col>
		</Row>
	);
};

SectionHeading.propTypes = {
	leftToolComponents: PropTypes.array,
	rightToolComponents: PropTypes.array,
};

SectionHeading.defaultProps = {
	leftToolComponents: [],
	rightToolComponents: [],
};

export default SectionHeading;
